<div class="row">
  <div class="col-md-12">
    <span mat-dialog-close matSuffix class="lbl">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <div class="col-md-12 text-center">
    <span class="MM30" *ngIf="data.mode === 'Add'">Add Doctor</span>
    <span class="MM30" *ngIf="data.mode === 'Edit'">Edit Doctor</span>
    <span class="MM30" *ngIf="data.mode === 'View'">View Doctor</span>
    <p class="MM18" *ngIf="data.mode === 'Add' || data.mode === 'Edit'">
      Fill in the Doctor Details
    </p>
    <p class="MM18" *ngIf="data.mode === 'View'">View Doctor Details</p>
  </div>
</div>
<mat-dialog-content class="mat-typography" [formGroup]="addDoctorForm">
  <div
    class="doctor_fields"
    *ngIf="data.mode === 'Add' || data.mode === 'Edit'"
  >
    <div class="row" style="margin-top: 1rem">
      <!--Regd No-->
      <div class="col-md-6">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex"
              >Registration Number <span class="text-danger">*</span></mat-label
            >
            <input
              tabindex="1"
              matInput
              placeholder="eg. 7897897"
              formControlName="registrationNumber"
              (blur)="
                getDoctorDetails(
                  this.addDoctorForm.controls['registrationNumber'].value,
                  'registrationNum'
                )
              "
            />
            <mat-error
              *ngIf="
                addDoctorForm.controls['registrationNumber'].touched &&
                addDoctorForm.controls['registrationNumber'].hasError(
                  'required'
                )
              "
            >
              Enter Registration No
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!--Contact No-->
      <div class="col-md-6">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex">Contact Number </mat-label>
            <input
              tabindex="3"
              matInput
              placeholder="88888 99999"
              formControlName="doctorContact"
              (blur)="
                getDoctorDetails(
                  this.addDoctorForm.controls['doctorContact'].value,
                  'phoneNum'
                )
              "
              #contactno
            />
            <mat-error
              *ngIf="
                addDoctorForm.controls['doctorContact'].touched &&
                addDoctorForm.controls['doctorContact'].hasError('required')
              "
            >
              Contact Number is required
            </mat-error>
            <mat-error
              *ngIf="
                addDoctorForm.controls['doctorContact'].hasError('pattern')
              "
            >
              Enter Valid Contact Number
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <!--Doctor Name-->
      <div class="col-md-6">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex"
              >Doctor's Name <span class="text-danger">*</span></mat-label
            >
            <input
              tabindex="2"
              matInput
              placeholder="eg. John Doe"
              formControlName="doctorName"
            />
            <mat-error
              *ngIf="
                addDoctorForm.controls['doctorName'].touched &&
                addDoctorForm.controls['doctorName'].hasError('required')
              "
            >
              Enter Doctor Name
            </mat-error>
            <mat-error
              *ngIf="addDoctorForm.controls['doctorName'].hasError('pattern')"
            >
              Enter Valid Name
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!--Email Id-->
      <div class="col-md-6">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex">Email ID </mat-label>
            <input
              matInput
              tabindex="4"
              placeholder="email_id@example.com"
              formControlName="doctorEmail"
            />
            <mat-error
              *ngIf="
                addDoctorForm.controls['doctorEmail'].touched &&
                addDoctorForm.controls['doctorEmail'].hasError('required')
              "
            >
              Enter Email ID
            </mat-error>
            <mat-error
              *ngIf="addDoctorForm.controls['doctorEmail'].hasError('pattern')"
            >
              Enter valid Email ID
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <!--Doctor Type-->
      <div class="col-md-6">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex"
              >Doctor Type <span class="text-danger">*</span></mat-label
            >
            <mat-select tabindex="5" formControlName="doctorType">
              <mat-option
                class="MM16"
                *ngFor="let type of types"
                [value]="type"
              >
                {{ type }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                addDoctorForm.controls['doctorType'].touched &&
                addDoctorForm.controls['doctorType'].hasError('required')
              "
            >
              Enter Doctor Type
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <!--Speciality-->
      <div class="col-md-6">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex">Speciality </mat-label>
            <mat-select tabindex="6" formControlName="speciality">
              <mat-option
                class="MM16"
                *ngFor="let specialityType of specialityTypes"
                [value]="specialityType"
              >
                {{ specialityType }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                addDoctorForm.controls['speciality'].touched &&
                addDoctorForm.controls['speciality'].hasError('required')
              "
            >
              Enter Speciality Name
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row">
      <!--Visting Days-->
      <div class="col-md-12">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex">Visiting Days </mat-label>
            <mat-select formControlName="visitingDays" multiple>
              <mat-option
                *ngFor="let day of days"
                [value]="day.day"
                (click)="switchDay(day)"
              >
                {{ day.day }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                addDoctorForm.controls['visitingDays'].touched &&
                addDoctorForm.controls['visitingDays'].hasError('required')
              "
            >
              Enter Visiting Days
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <!--Visiting Hours-->
    <div
      class="wrap"
      *ngFor="let day of days; let i = index; trackBy: trackByIdx"
    >
      <div class="row" *ngIf="day.isSelected">
        <div class="col-md-4 text-center">
          <div class="MM18" style="margin-top: 1.5rem">{{ day.day }}</div>
        </div>
        <div class="col-md-3">
          <div class="form-group whitespace_fix">
            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label class="label-flex">Visiting Hours Start</mat-label>
              <input
                matInput
                type="time"
                placeholder="eg. 11:00 AM to 6:00 PM"
                [(ngModel)]="visitingHoursStart[i]"
                (change)="showCopyButton(i)"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group whitespace_fix">
            <mat-form-field class="example-full-width" appearance="fill">
              <mat-label class="label-flex">Visiting Hours End </mat-label>
              <input
                matInput
                type="time"
                placeholder="eg. 11:00 AM to 6:00 PM"
                [(ngModel)]="visitingHoursEnd[i]"
                (change)="showCopyButton(i)"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-2">
          <button
            *ngIf="isShowCopyButton[i]"
            mat-raised-button
            color="primary"
            class="save_changes"
            (click)="copyVisitingTime(i)"
          >
            Copy
          </button>
        </div>
        <div class="col-md-4"></div>
        <div class="col-md-8" style="padding-bottom: 0.7rem">
          <span
            class="MMI16"
            style="color: red"
            *ngIf="
              this.minutesOfDay(visitingHoursStart[i]) >
              this.minutesOfDay(visitingHoursEnd[i])
            "
            >Invalid Start and End time for Shifts. Please verify before
            submitting.</span
          >
        </div>
      </div>
    </div>
    <div class="row">
      <!--Highest Education-->
      <div class="col-md-12">
        <div class="form-group whitespace_fix">
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label class="label-flex">Highest Education </mat-label>
            <input
              matInput
              placeholder="eg. MBBS"
              formControlName="highestEducation"
            />
            <mat-error
              *ngIf="
                addDoctorForm.controls['highestEducation'].touched &&
                addDoctorForm.controls['highestEducation'].hasError('required')
              "
            >
              Enter Highest Education
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
  <div
    class="doctor_view"
    style="margin: 2rem 0rem 1rem 0rem"
    *ngIf="data.mode === 'View'"
  >
    <div class="row">
      <div class="col-md-12">
        <div class="table_contact">
          <table
            mat-table
            [dataSource]="dataSource"
            class="contact_table mat-elevation-z8 MM14"
          >
            <ng-container matColumnDef="visitingDays">
              <th mat-header-cell *matHeaderCellDef>Visiting Days</th>
              <td mat-cell class="cell_space_util" *matCellDef="let element">
                {{ element.visitingDays }}
              </td>
            </ng-container>

            <ng-container matColumnDef="visitingHoursStart">
              <th mat-header-cell *matHeaderCellDef>Visiting Hours Start</th>
              <td mat-cell class="cell_space_util" *matCellDef="let element">
                {{ element.visitingHoursStart }}
              </td>
            </ng-container>

            <ng-container matColumnDef="visitingHoursEnd">
              <th mat-header-cell *matHeaderCellDef>Visiting Hours End</th>
              <td mat-cell class="cell_space_util" *matCellDef="let element">
                {{ element.visitingHoursEnd }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-paginator
            #doctorDetailsPaginator
            class="mat-elevation-z8 full-width-field"
            [length]="resultsLength"
            [pageSize]="6"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </div>
    </div>
  </div>
  <!--View Details Table-->
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div class="row">
    <div class="col-md-12">
      <button
        *ngIf="data.mode === 'Edit'"
        mat-raised-button
        color="primary"
        [disabled]="!addDoctorForm.valid"
        (click)="editDoctor()"
        class="save_changes"
        cdkFocusInitial
      >
        Save Changes
      </button>
      <button
        *ngIf="data.mode === 'Add'"
        mat-raised-button
        color="primary"
        [disabled]="!addDoctorForm.valid"
        (click)="addDoctor()"
        class="save_changes"
        cdkFocusInitial
      >
        Add
      </button>
    </div>
  </div>
</mat-dialog-actions>
